import React from 'react'

const RateLookMale = (props) => {

  const cardStyle = {}
  if(props.noShadow){
    cardStyle.boxShadow = 'none' 
  }

  return (
	<div className="fineryCard" style={cardStyle}>
    <div className="winCash"></div>
		<div className="fineryCardContent outfitRateImage">
			<div></div><h2>RATE THESE DATE LOOKS!</h2>
        <span>Match & FINERY (a new styling site) are teaming up to help you look great & win <strong>BIG</strong>. Here's how:</span>
				<p><strong>1) Browse today’s date looks</strong></p>
				<p><strong>2) Rate & react to each outfit</strong></p>
				<p><strong>3) Submit your ratings for a chance to win cash & prizes </strong></p>
    </div>
	</div>
)
}
export default RateLookMale;



// WEBPACK FOOTER //
// ./src/templates/RateLookMale.js